export const timeFormat = 'h.mm A';
